import React from 'react';
import ReactDOM from 'react-dom/client';
import '../../shared/styles/common.css';
import '../../shared/components/Header/Header.css';
import '../../shared/components/Footer/Footer.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
